// extracted by mini-css-extract-plugin
var _1 = "goHj5";
var _2 = "RdJ3T";
var _3 = "ewb2I";
var _4 = "cgvKl";
export { _1 as "base", _2 as "fill", _3 as "large", _4 as "nullScore" }
